/* Chat dock — Figma "W1440 · chat · docked · Cold start" / "· Results".
   No AI backend exists on this store, so responses are a short generic
   line (never a fabricated claim about specific products) while the
   product cards themselves are always real, live results from Shopify's
   own predictive search API — same "real data over fake text" rule used
   throughout this theme (Circle, wishlist, etc.). See the header comment
   in sections/chat-dock.liquid for the full reasoning. */
/* The (+) on add-to-cart buttons is one global image a merchant can upload
   (Theme settings > Add to cart button), rendered into window.VRO_ADD_ICON by
   layout/theme.liquid. Cards built as HTML strings here read it from there so
   they match the Liquid-rendered cards; the inline plus stays as the fallback
   for the case where the global never arrived.

   Assigned through the ||, not declared: this same helper lives in the other
   script that builds cards as strings, and two plain function declarations
   would silently clobber each other depending on load order. Whichever file
   the browser reaches first defines it; the other finds it already there. */
window.vroAddIconHtml = window.vroAddIconHtml || function (size) {
  var icons = window.VRO_ADD_ICON;
  if (icons && icons[size]) return icons[size];
  return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
};

document.addEventListener('DOMContentLoaded', function () {
  var dock = document.getElementById('chatDock');
  if (!dock) return;

  var resultsView = document.getElementById('chatDockResults');
  var coldView = dock.querySelector('[data-chat-dock-view="cold"]');
  var form = document.getElementById('chatDockForm');
  var input = document.getElementById('chatDockInput');
  var sendBtn = document.getElementById('chatDockSendBtn');
  var body = document.getElementById('chatDockBody');

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---- Open / close ---- */
  function openDock() {
    dock.removeAttribute('inert');
    dock.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { dock.classList.add('is-open'); });
    setTimeout(function () { input.focus(); }, 260);
  }
  function closeDock() {
    dock.classList.remove('is-open');
    dock.setAttribute('inert', '');
    dock.setAttribute('aria-hidden', 'true');
  }
  window.VroChatDock = { open: openDock, close: closeDock };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-chat-dock-open]')) { e.preventDefault(); openDock(); return; }
    if (e.target.closest('[data-chat-dock-close]') || e.target.closest('[data-chat-dock-minimize]')) { closeDock(); return; }
    if (e.target.closest('[data-chat-dock-reset]')) { resetToColdStart(); return; }

    var ideaBtn = e.target.closest('[data-chat-dock-query]');
    if (ideaBtn) { runSearch(ideaBtn.getAttribute('data-chat-dock-query')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && dock.classList.contains('is-open')) closeDock();
  });

  function resetToColdStart() {
    dock.classList.remove('is-results-mode');
    resultsView.hidden = true;
    resultsView.innerHTML = '';
    coldView.hidden = false;
    input.value = '';
    updateSendState();
  }

  /* ---- Input / send button ---- */
  function updateSendState() {
    sendBtn.disabled = !input.value.trim();
  }
  input.addEventListener('input', function () {
    updateSendState();
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 88) + 'px';
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = input.value.trim();
    if (!q) return;
    runSearch(q);
  });

  /* ---- Generic, non-fabricated intro lines — rotated by a light keyword
     match against the query, never a specific claim about the products
     returned (there's no real AI reading the query here). ---- */
  function introLineFor(query) {
    var q = query.toLowerCase();
    if (/wedding|shaadi|party/.test(q)) return "Here's a shortlist worth trying for the occasion.";
    if (/gym|sport|run|active/.test(q)) return "Pulled a few that fit what you're after.";
    if (/rain|monsoon|waterproof/.test(q)) return "Here's what's closest to what you described.";
    return "Here's what closely matches what you're looking for.";
  }

  function renderYouMessage(query) {
    resultsView.insertAdjacentHTML('beforeend',
      '<div class="chat-dock-msg-you"><div class="chat-dock-msg-you-bubble"></div></div>'
    );
    resultsView.lastElementChild.querySelector('.chat-dock-msg-you-bubble').textContent = query;
  }

  function renderLoading() {
    var wrap = document.createElement('div');
    wrap.className = 'chat-dock-msg-ai';
    wrap.id = 'chatDockLoadingMsg';
    wrap.innerHTML =
      '<div class="chat-dock-msg-ai-meta"><span class="chat-dock-header-diamond">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M11.313 8.932C12.077 7.444 12.459 6.7 12.998 6.7c.54 0 .921.744 1.685 2.232.751 1.462 1.877 2.593 3.339 3.344 1.487.764 2.231 1.146 2.231 1.685 0 .54-.744.921-2.231 1.685-1.462.752-2.588 1.882-3.34 3.344-.763 1.488-1.145 2.232-1.684 2.232-.539 0-.921-.744-1.685-2.232-.751-1.462-1.881-2.592-3.343-3.344-1.487-.763-2.231-1.145-2.231-1.685 0-.539.744-.92 2.231-1.685 1.462-.75 2.592-1.881 3.343-3.343Z" fill="#0080FF"/></svg>' +
      '</span> Finding matches</div>' +
      '<div class="chat-dock-results-loading"><span></span><span></span><span></span></div>';
    resultsView.appendChild(wrap);
  }

  function renderResults(query, products) {
    var loading = document.getElementById('chatDockLoadingMsg');
    if (loading) loading.remove();

    if (!products.length) {
      resultsView.insertAdjacentHTML('beforeend',
        '<div class="chat-dock-msg-ai">' +
          '<div class="chat-dock-msg-ai-meta"><span class="chat-dock-header-diamond"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M11.313 8.932C12.077 7.444 12.459 6.7 12.998 6.7c.54 0 .921.744 1.685 2.232.751 1.462 1.877 2.593 3.339 3.344 1.487.764 2.231 1.146 2.231 1.685 0 .54-.744.921-2.231 1.685-1.462.752-2.588 1.882-3.34 3.344-.763 1.488-1.145 2.232-1.684 2.232-.539 0-.921-.744-1.685-2.232-.751-1.462-1.881-2.592-3.343-3.344-1.487-.763-2.231-1.145-2.231-1.685 0-.539.744-.92 2.231-1.685 1.462-.75 2.592-1.881 3.343-3.343Z" fill="#0080FF"/></svg></span> No matches yet</div>' +
          '<p class="chat-dock-msg-ai-text">Nothing matched "' + escapeHtml(query) + '" — try a different word, or browse everything instead.</p>' +
          '<div class="chat-dock-results-empty"><a href="/collections/bestsellers" class="chat-dock-idea-label" style="color:var(--vro-blue)">Browse bestsellers →</a></div>' +
        '</div>'
      );
      return;
    }

    /* /search/suggest.json is an autocomplete endpoint, capped at
       resources[limit] — it doesn't return a real total-match count, so
       (unlike the Figma "4 from 120" copy) this only ever states the
       number actually shown, never a fabricated total. */
    var html =
      '<div class="chat-dock-msg-ai">' +
        '<div class="chat-dock-msg-ai-meta"><span class="chat-dock-header-diamond"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M11.313 8.932C12.077 7.444 12.459 6.7 12.998 6.7c.54 0 .921.744 1.685 2.232.751 1.462 1.877 2.593 3.339 3.344 1.487.764 2.231 1.146 2.231 1.685 0 .54-.744.921-2.231 1.685-1.462.752-2.588 1.882-3.34 3.344-.763 1.488-1.145 2.232-1.684 2.232-.539 0-.921-.744-1.685-2.232-.751-1.462-1.881-2.592-3.343-3.344-1.487-.763-2.231-1.145-2.231-1.685 0-.539.744-.92 2.231-1.685 1.462-.75 2.592-1.881 3.343-3.343Z" fill="#0080FF"/></svg></span> ' + products.length + ' match' + (products.length === 1 ? '' : 'es') + '</div>' +
        '<p class="chat-dock-msg-ai-text">' + escapeHtml(introLineFor(query)) + '</p>' +
        '<div class="chat-dock-results-rail">';

    products.forEach(function (p) {
      // Full /products/{handle}.js shape (fetched per-handle after the
      // search call below finds the matches) — same shape wishlist.js and
      // the Circle feature already use, so this reuses their exact
      // field/unit conventions instead of guessing at a third shape:
      // featured_image is a plain URL string, price/compare_at_price are
      // integer paise, and variants[0].id is a real, addable variant —
      // unlike /search/suggest.json, whose product objects carry an
      // always-empty variants array, which would've made "add to bag"
      // silently do nothing.
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var price = p.price / 100;
      var compareAt = p.compare_at_price ? p.compare_at_price / 100 : 0;
      var priceText = isNaN(price) ? '' : '₹' + price.toLocaleString('en-IN', { maximumFractionDigits: 0 });
      var discountHtml = '';
      if (compareAt && compareAt > price) {
        var pct = Math.round((compareAt - price) * 100 / compareAt);
        discountHtml = '<span class="chat-dock-result-discount">' + pct + '% off</span>';
      }
      var variantId = (p.variants && p.variants[0] && p.variants[0].id) || '';
      html +=
        '<div class="chat-dock-result-card">' +
          '<a href="/products/' + p.handle + '" class="chat-dock-result-img-wrap">' +
            (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=280" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
            '<button type="button" class="chat-dock-result-add" data-add-variant="' + variantId + '" aria-label="Add to bag" onclick="event.preventDefault()">' + window.vroAddIconHtml(14) + '</button>' +
          '</a>' +
          '<p class="chat-dock-result-vendor">' + escapeHtml(p.vendor) + '</p>' +
          '<p class="chat-dock-result-title">' + escapeHtml(p.title) + '</p>' +
          '<p class="chat-dock-result-price">' + priceText + discountHtml + '</p>' +
        '</div>';
    });

    html += '</div></div>';
    resultsView.insertAdjacentHTML('beforeend', html);

    resultsView.querySelectorAll('[data-add-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-add-variant');
        if (!variantId) return;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
          .then(function () {
            if (window.showToast) window.showToast('Added to bag');
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) { if (window.updateCartCount) window.updateCartCount(cart.item_count); })
          .catch(function () { if (window.showToast) window.showToast('Could not add — try again'); })
          .finally(function () { btn.disabled = false; });
      });
    });
  }

  function runSearch(query) {
    query = (query || '').trim();
    if (!query) return;

    if (!dock.classList.contains('is-open')) openDock();
    dock.classList.add('is-results-mode');
    coldView.hidden = true;
    resultsView.hidden = false;

    renderYouMessage(query);
    input.value = '';
    updateSendState();
    renderLoading();
    body.scrollTop = body.scrollHeight;

    // Two-step lookup: /search/suggest.json finds real matching handles
    // for the typed query (that part of Shopify's own search relevance
    // IS real), then each handle's full /products/{handle}.js is fetched
    // for accurate price/image/variant data — see the comment in
    // renderResults() for why the suggest endpoint's own product shape
    // isn't usable directly (empty variants, cents-vs-rupees mismatch).
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var resource = data && data.resources && data.resources.results;
        var handles = ((resource && resource.products) || []).map(function (p) { return p.handle; });
        return Promise.all(handles.map(function (h) {
          return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        }));
      })
      .then(function (products) {
        renderResults(query, products.filter(Boolean));
        body.scrollTop = body.scrollHeight;
      })
      .catch(function () {
        renderResults(query, []);
      });
  }
});
